import { ref } from 'vue';

const useEventListener = key => {
  const emit = detail => {
    document.dispatchEvent(new CustomEvent(key, { detail }));
  };

  const createListener = callback => event => { callback(event.detail); };

  const eventInstance = ref(null);

  const listen = callback => {
    eventInstance.value = createListener(callback);
    document.addEventListener(key, eventInstance.value);
  };

  const dispose = () => {
    document.removeEventListener(key, eventInstance.value);
    eventInstance.value = null;
  };

  return {
    emit,
    listen,
    dispose,
  };
};

export default useEventListener;
